import api from '../../services/api';

export interface Questions {
  id: number;
  pregunta: string;
  respuesta: string;
  activa: string;
  created_at: Date;
  updated_at: null;
}

async function getQuestions(searchWord: string) {
  const response = await api<Questions[]>(
    'GET',
    `preguntas?search=${searchWord}`
  );

  return response;
}

const questionsAPI = {
  getQuestions,
};

export default questionsAPI;
